import ProfileActionConstants from '../constants/actions/ProfileActionConstants';
import { IUser } from '../types';

const ProfileActions = {
    getProfile,
    getProfileSuccess,
    getProfileFail,
    saveProfile,
};

function getProfile(userId: number) {
    return {
        type: ProfileActionConstants.GET_PROFILE,
        payload: { userId },
    };
}

function getProfileSuccess(user: IUser) {
    return {
        type: ProfileActionConstants.GET_PROFILE_SUCCESS,
        payload: user,
    };
}

function getProfileFail(error: string) {
    return {
        type: ProfileActionConstants.GET_PROFILE_FAIL,
        error,
    };
}

export type SaveProfilePayload = {
    userId: number;
    firstName?: string;
    lastName?: string;
};

export type SaveProfileAction = {
    type: typeof ProfileActionConstants.SAVE_PROFILE;
    payload: SaveProfilePayload;
};

function saveProfile(
    userId: number,
    firstName?: string,
    lastName?: string,
): SaveProfileAction {
    return {
        type: ProfileActionConstants.SAVE_PROFILE,
        payload: { userId, firstName, lastName },
    };
}

export default ProfileActions;
